import { useEffect, useState } from "react";
import { ApiClientError } from "../../lib/api/client";
import { useCreateStudentMutation } from "../../lib/api/scholarships";
import { Button } from "../../components/ui/Button";
import { Modal } from "../../components/ui/Modal";

interface CreateStudentModalProps {
  open: boolean;
  onClose: () => void;
}

export function CreateStudentModal({ open, onClose }: CreateStudentModalProps) {
  const createStudent = useCreateStudentMutation();
  const [name, setName] = useState("");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!open) {
      setName("");
      setError(null);
    }
  }, [open]);

  async function submit() {
    setError(null);
    try {
      await createStudent.mutateAsync({ name });
      onClose();
    } catch (err) {
      setError(err instanceof ApiClientError ? err.message : "Could not create student.");
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Add student"
      description="Students can receive multiple scholarship awards over time."
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button disabled={createStudent.isPending} onClick={() => void submit()}>
            {createStudent.isPending ? "Saving…" : "Save student"}
          </Button>
        </>
      }
    >
      <div className="grid gap-4">
        {error ? (
          <p className="edlab-error">
            {error}
          </p>
        ) : null}
        <label className="grid gap-1 text-sm">
          Student name
          <input
            className="edlab-input"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
        </label>
      </div>
    </Modal>
  );
}
